import { Pipe, PipeTransform } from '@angular/core';
import { Movie } from '../services/Page/page.service';

@Pipe({
    name: 'orderByDate'
})
export class OrderByDatePipe implements PipeTransform {

    transform(movie: Movie[], skipSort:string = ''): Movie[] {
        if(skipSort == 'skip') {
            return movie
        }
        
        return movie.sort((a, b) => {
            return a.Release - b.Release
        })
    }

}
